import { VariantKey, Variant } from './types';

import defaultVariant from './default';
import apps from './apps';
import analyze from './analyze';
import billing from './billing';
import developer from './developer';
import mrx from './mrx';

export * from './types';
export const VARIANTS: Record<Required<VariantKey>, Variant> = {
  analyze,
  apps,
  billing,
  default: defaultVariant,
  developer,
  mrx,
};
